module.exports = __webpack_public_path__ + "media/icons/thief-circle-78px-b7006301.png";